/* Boring/simple callback-based observable for change management. Can be replaced by a more robust library,
   let's just avoid imposing a lot of frameworky opinions on Applet users.
*/

import { attachHandler } from './utils';

export type BasicObserver<T> = (newValue: T, oldValue: T) => void;

export default class BasicObservable<T> {
  #currentValue: T;

  #observers: BasicObserver<T>[] = [];

  constructor(value: T) {
    this.#currentValue = value;
  }

  get value(): T {
    return this.#currentValue;
  }

  set value(newValue: T) {
    const oldValue = this.#currentValue;
    this.#currentValue = newValue;

    for (const observer of this.#observers) {
      observer(newValue, oldValue);
    }
  }

  onChange(observer: BasicObserver<T>): () => void {
    return attachHandler(this.#observers, observer);
  }
}
